export default __webpack_public_path__ + "static/media/home-dentist-icon-07.a42265cd.svg";